import { useQuery } from '@apollo/client';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';

import { reportsApi } from '../api';
import { toAsyncResource } from '../lib';
import { ConversionTableSorting } from '../types';
import {
  LenderPerformanceTrendQueryResponse,
  LenderPerformanceFunnelQueryResponse,
  LenderPerformanceRatioCardsQueryResponse,
  LenderPerformanceTrendByLenderQueryResponse,
  LenderPerformanceConversionTableQueryResponse,
} from '../api/types';

export const useLenderPerformanceConversionFunnel = (
  input: LenderPerformanceReportInput,
  sorting: ConversionTableSorting
) => {
  const ratioCardsResponse = useQuery<LenderPerformanceRatioCardsQueryResponse>(
    reportsApi.getLenderPerformanceRatioCards,
    {
      variables: {
        input,
      },
    }
  );

  const funnelResponse = useQuery<LenderPerformanceFunnelQueryResponse>(reportsApi.getLenderPerformanceFunnel, {
    variables: {
      input,
    },
  });

  const conversionTableResponse = useQuery<LenderPerformanceConversionTableQueryResponse>(
    reportsApi.getLenderPerformanceConversionTable,
    {
      variables: {
        input: { ...input, sorting },
      },
    }
  );

  const trendResponse = useQuery<LenderPerformanceTrendQueryResponse>(reportsApi.getLenderPerformanceTrend, {
    variables: {
      input,
    },
  });

  const trendByLenderResponse = useQuery<LenderPerformanceTrendByLenderQueryResponse>(
    reportsApi.getLenderPerformanceTrendByLender,
    {
      variables: {
        input,
      },
    }
  );

  return {
    trend: toAsyncResource(trendResponse, []),
    funnel: toAsyncResource(funnelResponse, null),
    trendByLender: toAsyncResource(trendByLenderResponse, []),
    ratioCards: toAsyncResource(ratioCardsResponse, null),
    conversionTable: toAsyncResource(conversionTableResponse, []),
    isLoading:
      ratioCardsResponse.loading ||
      funnelResponse.loading ||
      conversionTableResponse.loading ||
      trendResponse.loading ||
      trendByLenderResponse.loading,
  };
};
